import React, { useEffect, useRef } from 'react';

// DiscoverCars car-rental search widget. The provider ships a <script> that reads its own
// data-* attributes and renders the widget where the script is placed. React can't use
// dangerouslySetInnerHTML for this (injected <script> tags don't execute), so we build the
// element via the DOM API and append it to our container.
const ATTRS = {
  'data-dev-env': 'com',
  'data-location': '',
  'data-lang': 'en',
  'data-utm-source': 'Flightdeals',
  'data-utm-medium': 'widget',
  'data-aff-code': 'a_aid',
  'data-autocomplete': 'on',
  'data-style-submit-bg-color': '#00b87a',
  'data-style-submit-font-color': '#ffffff',
  'data-style-form-bg-color': '#ffffff',
  'data-style-form-font-color': '#000000',
  'data-style-submit-text': 'Search Now',
  'data-style-title-color': '#000000',
  'data-title-text': 'Search and compare car rentals and save up to 70%!',
  'data-style_rounded_corners': 'on',
  'data-localization_currency_box': 'on',
  'data-layout_benefits': 'on',
  'data-layout_description': 'on',
  'data-layout_description_text': "We've selected the best deals from our car rental partners.",
  'data-layout_title': 'on',
  'data-layout_supplier_logos': 'on',
};

export const DiscoverCarsWidget = ({ testid = 'discovercars-widget' }) => {
  const ref = useRef(null);

  useEffect(() => {
    const host = ref.current;
    if (!host) return;
    // Guard against double-injection (React StrictMode re-invokes effects; a second live
    // script would render the widget twice). On real navigation React removes this container
    // node — and the script inside it — so re-entry re-injects cleanly.
    if (document.getElementById('dchwidget')) return;

    const s = document.createElement('script');
    s.id = 'dchwidget';
    s.src = 'https://www.discovercars.com/widget.js?v1';
    s.async = true;
    Object.entries(ATTRS).forEach(([k, v]) => s.setAttribute(k, v));
    host.appendChild(s);
  }, []);

  return <div ref={ref} data-testid={testid} className="min-h-[320px]" />;
};
